/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Kpi_TotalInputs */



/**
* | output |
* | --- |
* | "Total feedback" |
*
* @param {Feedback_Kpi_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_kpi_total = /** @type {((inputs?: Feedback_Kpi_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Kpi_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewertungen gesamt")
	return /** @type {LocalizedString} */ ("Total feedback")
});